import { render, staticRenderFns } from "./Addbot.vue?vue&type=template&id=13439ca6&scoped=true&lang=html&"
import script from "./Addbot.vue?vue&type=script&lang=js&"
export * from "./Addbot.vue?vue&type=script&lang=js&"
import style0 from "./Addbot.vue?vue&type=style&index=0&id=13439ca6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13439ca6",
  null
  
)

export default component.exports